export const CONVERSATION = 'conversation';
export const CUSTOMER_TYPING_INDICATOR = 'customer-typing-indicator';
export const FILTERED_ITEMS = 'filtered-items';
export const ITEM = 'item';
export const UNREAD_DIVIDER = 'unread';
export const LAST_CONVERSATION_SPACER = 'last-conversation-spacer';
export const LAST_CONVERSATION_SPACER_ID = 'last-conversation-spacer-id';
